import bahasaIcon from "@assets/header/menu/icon/bahasa.svg";
import bahasaSelected from "@assets/header/menu/icon/bahasa-selected.svg";
import dollarIcon from "@assets/header/menu/icon/dollar.svg";
import duniaIcon from "@assets/header/menu/icon/dunia.svg";
import ekoniagaIcon from "@assets/header/menu/icon/ekoniaga.svg";
import ghIcon from "@assets/header/menu/icon/gaya-hidup.svg";
import gengIcon from "@assets/header/menu/icon/gen-g.svg";
import gengIconSelected from "@assets/header/menu/icon/gen-g-white.svg";
import malaysiaIcon from "@assets/header/menu/icon/malaysia.svg";
import podcastIcon from "@assets/header/menu/icon/podcast.svg";
import premiumIcon from "@assets/header/menu/icon/premium.svg";
import singapuraIcon from "@assets/header/menu/icon/singapura.svg";
import sukanIcon from "@assets/header/menu/icon/sukan.svg";
import userIcon from "@assets/header/menu/icon/user.svg";
import videoIcon from "@assets/header/menu/icon/video.svg";
import wacanaIcon from "@assets/header/menu/icon/wacana.svg";
import ghIconSelected from "@assets/header/menu-selected/icon/gaya-hidup.svg";
import malaysiaIconSelected from "@assets/header/menu-selected/icon/malaysia.svg";
import singapuraIconSelected from "@assets/header/menu-selected/icon/singapura.svg";
import mybhIcon from "@assets/header/mybh-logo.svg";
import { ENABLE_MYBH, MYBH_LINK } from "@config/followTopic";
import {
  ENABLE_KAKI_MAKAN,
  KAKI_MAKAN_LANDING_PAGE,
  KAKI_MAKAN_REF_CODE_MENU,
} from "@config/kakiMakan";
import { EPAPER_LINK } from "@helper/getEnvVariables";

import {
  DUNIA_SUB_SECTION,
  EKONOMI_SUB_SECTION,
  GAYA_HIDUP_SUB_SECTION,
  MULTIMEDIA_SUB_SECTION,
  SINGAPURA_SUB_SECTION,
  WACANA_SUB_SECTION,
} from "./subCategoriesConstants";

export type SectionDetails = Readonly<{
  title: string;
  url: string;
  images?: string | undefined;
  newTab?: boolean | undefined;
  selectedColor?: string | undefined;
  selectedIcon?: string | undefined;
  neutralColor?: boolean | undefined;
}>;

export type SectionMobileDetails = Readonly<{
  title: string;
  subtype: string;
  display_format: string;
  limit: number;
  title_clickable: boolean;
  cat_name: string;
}>;

export type SectionMobileAppDetails = Readonly<{
  title: string;
  subtype: string;
  display_format: string;
  limit?: number;
  title_clickable?: boolean;
  cat_name?: string;
  term_name?: string;
  display_name?: string;
  section?: SectionMobile;
}>;

export type SectionMobile = Readonly<{
  code: string;
  name: string;
  feed: string;
  type: string;
  level?: number;
}>;

export const SECTION_LIST_NEW: SectionDetails[] = [
  {
    title: "Singapura",
    url: "/singapura",
    images: singapuraIcon,
    selectedColor: "red-100",
    selectedIcon: singapuraIconSelected,
  },
  {
    title: "Malaysia",
    url: "/malaysia",
    images: malaysiaIcon,
    selectedColor: "pink-600",
    selectedIcon: malaysiaIconSelected,
  },
  {
    title: "Dunia",
    url: "/dunia",
    selectedColor: "pink-600",
    images: duniaIcon,
    selectedIcon: duniaIcon,
  },
  {
    title: "Ekonomi",
    url: "/ekonomi-kerja",
    selectedColor: "green-400",
    images: ekoniagaIcon,
    selectedIcon: ekoniagaIcon,
  },
  {
    title: "Gaya Hidup",
    url: "/gaya-hidup",
    images: ghIcon,
    selectedColor: "red-600",
    selectedIcon: ghIconSelected,
  },
  {
    title: "Wacana",
    url: "/wacana",
    selectedColor: "violet-300",
    images: wacanaIcon,
    selectedIcon: wacanaIcon,
  },
  {
    title: "Sukan",
    url: "/sukan",
    selectedColor: "orange-300",
    images: sukanIcon,
    selectedIcon: sukanIcon,
  },
  {
    title: "Bahasa & Budaya",
    url: "/bahasa-budaya",
    selectedColor: "pink-500",
    images: bahasaIcon,
    selectedIcon: bahasaSelected,
  },
  {
    title: "Multimedia",
    url: "/podcasts",
    selectedColor: "blue-400",
    neutralColor: true,
  },
  {
    title: "Gen G",
    url: "/gen-g",
    images: gengIcon,
    selectedColor: "blue-150",
    selectedIcon: gengIconSelected,
  },
];

export const SECONDARY_SECTION_LIST_NEW: SectionDetails[] = [
  {
    title: "Akses Percuma",
    url: "/akses-percuma",
    selectedColor: "blue-400",
    images: dollarIcon,
    selectedIcon: dollarIcon,
  },
  {
    title: "Premium",
    url: "/premium-articles",
    selectedColor: "violet-200",
    images: premiumIcon,
    selectedIcon: premiumIcon,
  },
  {
    title: "Pengguna Berdaftar",
    url: "/registered",
    selectedColor: "purple-300",
    images: userIcon,
    selectedIcon: userIcon,
  },
  {
    title: "Kuiz BH",
    url: "/kuiz-bh",
  },
  {
    title: "mata-mata",
    url: "/mata-mata?ref=menu",
    selectedColor: "blue-300",
  },
  ENABLE_KAKI_MAKAN && {
    title: "Kaki Makan",
    url: `/${KAKI_MAKAN_LANDING_PAGE}${KAKI_MAKAN_REF_CODE_MENU}`,
  },
  {
    title: "Webinar",
    url: "/webinar",
  },
  {
    title: "BH Services",
    url: "/bh-services",
  },
].filter(Boolean) as SectionDetails[];

export const MISC_LIST: SectionDetails[] = [
  ENABLE_MYBH && {
    title: "BHku",
    url: `/${MYBH_LINK}?ref=mybh-menu`,
    images: mybhIcon,
  },
  {
    title: "eNewsletter",
    url: "/ringkasan-berita-harian",
  },
  {
    title: "Sekilas Berita",
    url: "/quick-news?ref=top-menu-quick-news",
  },
  {
    title: "ePaper",
    url: EPAPER_LINK,
    newTab: true,
  },
].filter(Boolean) as SectionDetails[];

export const MOBILE_MAIN_LIST: SectionDetails[] = [
  {
    title: "Kuiz BH",
    url: "/kuiz-bh",
  },
  {
    title: "mata-mata",
    url: "/mata-mata?ref=menu",
  },
  ENABLE_KAKI_MAKAN && {
    title: "Kaki Makan",
    url: `/${KAKI_MAKAN_LANDING_PAGE}${KAKI_MAKAN_REF_CODE_MENU}`,
  },
  {
    title: "Webinar",
    url: "/webinar",
  },
  {
    title: "BH Services",
    url: "/bh-services",
  },
].filter(Boolean) as SectionDetails[];

export const MOBILE_SECTION_LIST: SectionDetails[] = [
  {
    title: "Singapura",
    url: "/singapura",
    images: singapuraIcon,
    selectedColor: "red-100",
    selectedIcon: singapuraIcon,
  },
  {
    title: "Malaysia",
    url: "/malaysia",
    images: malaysiaIcon,
    selectedColor: "pink-600",
    selectedIcon: malaysiaIcon,
  },
  {
    title: "Dunia",
    url: "/dunia",
  },
  {
    title: "Ekonomi",
    url: "/ekonomi-kerja",
  },
  {
    title: "Gaya Hidup",
    url: "/gaya-hidup",
    images: ghIcon,
    selectedColor: "red-600",
    selectedIcon: ghIcon,
  },
  {
    title: "Hidayah",
    url: "/hidayah",
  },
  {
    title: "Wacana",
    url: "/wacana",
  },
  {
    title: "Sukan",
    url: "/sukan",
  },
  {
    title: "Bahasa & Budaya",
    url: "/bahasa-budaya",
    selectedColor: "pink-500",
    images: bahasaIcon,
    selectedIcon: bahasaSelected,
  },
  {
    title: "Podcast",
    url: "/podcasts",
    images: podcastIcon,
    selectedColor: "blue-400",
  },
  {
    title: "Videos",
    url: "/videos",
    images: videoIcon,
    selectedColor: "blue-400",
  },
  {
    title: "Gen-G",
    url: "/gen-g",
  },
];

export const MOBILE_MISC_LIST: SectionDetails[] = [
  {
    title: "Sekilas Berita",
    url: "/quick-news?ref=top-menu-quick-news",
  },
  {
    title: "eNewsletter",
    url: "/ringkasan-berita-harian",
  },
  {
    title: "ePaper",
    url: EPAPER_LINK,
    newTab: true,
  },
];

export const MOBILE_SECONDARY_LISTING: SectionDetails[] = [
  {
    title: "Akses Percuma",
    url: "/akses-percuma",
  },
  {
    title: "Premium",
    url: "/premium-articles",
  },
  {
    title: "Pengguna Berdaftar",
    url: "/registered",
  },
];

export const NON_HEADER_NEW: SectionDetails[] = [
  {
    title: "Rencana",
    url: "/rencana",
    selectedColor: "red-200",
  },
  {
    title: "Berita Utama",
    url: "/berita-utama",
    selectedColor: "red-100",
  },
  {
    title: "Kisah Zakat",
    url: "/kisah-zakat",
    selectedColor: "red-100",
  },
  {
    title: "Kesihatan",
    url: "/kesihatan",
    selectedColor: "red-100",
  },
];

export const MOBILE_SECTION_LIST_NEW: Record<string, SectionDetails[]> = {
  Singapura: SINGAPURA_SUB_SECTION,
  Malaysia: [
    {
      title: "Malaysia",
      url: "/malaysia",
      selectedColor: "pink-600",
    },
  ],
  Dunia: DUNIA_SUB_SECTION,
  Ekonomi: EKONOMI_SUB_SECTION,
  "Gaya Hidup": GAYA_HIDUP_SUB_SECTION,
  Wacana: WACANA_SUB_SECTION,
  Sukan: [
    {
      title: "Sukan",
      url: "/sukan",
      selectedColor: "orange-300",
    },
  ],
  "Bahasa & Budaya": [
    {
      title: "Bahasa & Budaya",
      url: "/bahasa-budaya",
      selectedColor: "pink-500",
    },
  ],
  Multimedia: MULTIMEDIA_SUB_SECTION,
  "Gen G": [
    {
      title: "Gen-G",
      url: "/gen-g",
      selectedColor: "blue-900",
    },
  ],
};

export const SECTION_LIST_MOBILE_APP: SectionMobileAppDetails[] = [
  {
    title: "Singapura",
    subtype: "title_bar",
    display_format: "SectionTitle",
    cat_name: "Singapura",
    section: {
      code: "singapura",
      name: "singapura",
      feed: "singapura",
      type: "section",
      level: 1,
    },
  },
  {
    title: "Singapura Category",
    subtype: "articles_by_category",
    display_format: "vertical_list",
    limit: 4,
    title_clickable: true,
    cat_name: "Singapura",
  },
  {
    title: "Laporan lain Singapura",
    subtype: "bottom_bar",
    display_format: "SectionFooter",
    display_name: "Laporan lain",
    cat_name: "Singapura",
    section: {
      code: "singapura",
      name: "Singapura",
      feed: "singapura",
      type: "section",
      level: 1,
    },
  },
  {
    title: "Malaysia",
    subtype: "title_bar",
    display_format: "SectionTitle",
    cat_name: "Malaysia",
    section: {
      code: "malaysia",
      name: "Malaysia",
      feed: "malaysia",
      type: "section",
      level: 1,
    },
  },
  {
    title: "Malaysia Category",
    subtype: "articles_by_category",
    display_format: "horizontal_list",
    limit: 5,
    title_clickable: true,
    cat_name: "Malaysia",
  },
  {
    title: "Kaki Jalan",
    subtype: "title_bar",
    display_format: "SectionTitle",
    term_name: "Kaki Jalan",
    section: {
      code: "kaki-jalan",
      name: "Kaki Jalan",
      feed: "Kaki Jalan",
      type: "keyword",
      level: 1,
    },
  },
  {
    title: "Kaki Jalan Keyword",
    subtype: "articles_by_keyword",
    display_format: "horizontal_list",
    limit: 5,
    title_clickable: true,
    term_name: "Kaki Jalan",
  },
  {
    title: "Kaki Makan",
    subtype: "title_bar",
    display_format: "SectionTitle",
    term_name: "Kaki Makan",
    section: {
      code: "kaki-makan",
      name: "Kaki Makan",
      feed: "Kaki Makan",
      type: "keyword",
      level: 1,
    },
  },
  {
    title: "Kaki Makan Keyword",
    subtype: "articles_by_keyword",
    display_format: "horizontal_list",
    limit: 5,
    title_clickable: true,
    term_name: "Kaki Makan",
  },
  {
    title: "DNA Dunia Anak",
    subtype: "title_bar",
    display_format: "SectionTitle",
    term_name: "DNA Dunia Anak",
    section: {
      code: "dna-dunia-anak",
      name: "DNA Dunia Anak",
      feed: "DNA Dunia Anak",
      type: "keyword",
      level: 1,
    },
  },
  {
    title: "DNA Dunia Anak Keyword",
    subtype: "articles_by_keyword",
    display_format: "horizontal_list",
    limit: 5,
    title_clickable: true,
    term_name: "DNA Dunia Anak",
  },
  {
    title: "Gaya Hidup",
    subtype: "title_bar",
    display_format: "SectionTitle",
    cat_name: "Gaya Hidup",
    section: {
      code: "gaya-hidup",
      name: "Gaya Hidup",
      feed: "gaya-hidup",
      type: "section",
      level: 1,
    },
  },
  {
    title: "Gaya Hidup Category",
    subtype: "articles_by_category",
    display_format: "vertical_list",
    limit: 4,
    title_clickable: true,
    cat_name: "Gaya Hidup",
  },
  {
    title: "Laporan lain Gaya Hidup",
    subtype: "bottom_bar",
    display_format: "SectionFooter",
    display_name: "Laporan lain",
    cat_name: "Gaya Hidup",
    section: {
      code: "gaya-hidup",
      name: "Gaya Hidup",
      feed: "gaya-hidup",
      type: "section",
      level: 1,
    },
  },
  {
    title: "Pengguna Berdaftar",
    subtype: "title_bar",
    display_format: "SectionTitle",
    cat_name: "register",
    section: {
      code: "pengguna-berdaftar",
      name: "Pengguna Berdaftar",
      feed: "https://www.beritaharian.sg/registered?mobwebview=true",
      type: "url",
      level: 1,
    },
  },
];

export const SECTION_LIST_MOBILE: SectionMobileDetails[] = [
  {
    title: "Singapura Category",
    subtype: "articles_by_category",
    display_format: "vertical_list",
    limit: 3,
    title_clickable: true,
    cat_name: "Singapura",
  },
  {
    title: "Dunia Category",
    subtype: "articles_by_category",
    display_format: "vertical_list",
    limit: 3,
    title_clickable: true,
    cat_name: "Dunia",
  },
  {
    title: "Wacana Category",
    subtype: "articles_by_category",
    display_format: "vertical_list",
    limit: 3,
    title_clickable: true,
    cat_name: "Wacana",
  },
  {
    title: "Sukan Category",
    subtype: "articles_by_category",
    display_format: "horizontal_list",
    limit: 4,
    title_clickable: true,
    cat_name: "Sukan",
  },
  {
    title: "Gaya Hidup Category",
    subtype: "articles_by_category",
    display_format: "horizontal_list",
    limit: 4,
    title_clickable: true,
    cat_name: "Gaya Hidup",
  },
];
